/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { CompanyLegalIdentifierResource } from './';
import {
    CompanyLegalIdentifierResourceFromJSON,
    CompanyLegalIdentifierResourceFromJSONTyped,
    CompanyLegalIdentifierResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FinancingAnalysisViolationResource
 */
export interface FinancingAnalysisViolationResource {
    /**
     * 
     * @type {string}
     * @memberof FinancingAnalysisViolationResource
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof FinancingAnalysisViolationResource
     */
    companyIdentityId: string;
    /**
     * 
     * @type {string}
     * @memberof FinancingAnalysisViolationResource
     */
    payingEntityId?: string;
    /**
     * 
     * @type {CompanyLegalIdentifierResource}
     * @memberof FinancingAnalysisViolationResource
     */
    companyLegalIdentifier: CompanyLegalIdentifierResource;
    /**
     * 
     * @type {string}
     * @memberof FinancingAnalysisViolationResource
     */
    violationType: FinancingAnalysisViolationResourceViolationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FinancingAnalysisViolationResource
     */
    violationDescription: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof FinancingAnalysisViolationResource
     */
    legalEntityIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FinancingAnalysisViolationResource
     */
    concernedFinancingPartners: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof FinancingAnalysisViolationResource
     */
    detectedAt: Date;
}


/**
 * @export
 */
export const FinancingAnalysisViolationResourceViolationTypeEnum = {
    MultipleFinancingPartners: 'MULTIPLE_FINANCING_PARTNERS',
    CreditLimitInconsistency: 'CREDIT_LIMIT_INCONSISTENCY',
    MultipleCreditLimits: 'MULTIPLE_CREDIT_LIMITS',
    FinancingEnabledWithoutPartner: 'FINANCING_ENABLED_WITHOUT_PARTNER',
    IllegalInvoicingSubsidiary: 'ILLEGAL_INVOICING_SUBSIDIARY',
    SharedCreditLimits: 'SHARED_CREDIT_LIMITS'
} as const;
export type FinancingAnalysisViolationResourceViolationTypeEnum = typeof FinancingAnalysisViolationResourceViolationTypeEnum[keyof typeof FinancingAnalysisViolationResourceViolationTypeEnum];


/**
 * Check if a given object implements the FinancingAnalysisViolationResource interface.
 */
export function instanceOfFinancingAnalysisViolationResource(value: object): value is FinancingAnalysisViolationResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyIdentityId' in value) || value['companyIdentityId'] === undefined) return false;
    if (!('companyLegalIdentifier' in value) || value['companyLegalIdentifier'] === undefined) return false;
    if (!('violationType' in value) || value['violationType'] === undefined) return false;
    if (!('violationDescription' in value) || value['violationDescription'] === undefined) return false;
    if (!('legalEntityIds' in value) || value['legalEntityIds'] === undefined) return false;
    if (!('concernedFinancingPartners' in value) || value['concernedFinancingPartners'] === undefined) return false;
    if (!('detectedAt' in value) || value['detectedAt'] === undefined) return false;
    return true;
}

export function FinancingAnalysisViolationResourceFromJSON(json: any): FinancingAnalysisViolationResource {
    return FinancingAnalysisViolationResourceFromJSONTyped(json, false);
}

export function FinancingAnalysisViolationResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancingAnalysisViolationResource {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyIdentityId': json['companyIdentityId'],
        'payingEntityId': json['payingEntityId'] == null ? undefined : json['payingEntityId'],
        'companyLegalIdentifier': CompanyLegalIdentifierResourceFromJSON(json['companyLegalIdentifier']),
        'violationType': json['violationType'],
        'violationDescription': json['violationDescription'],
        'legalEntityIds': json['legalEntityIds'],
        'concernedFinancingPartners': json['concernedFinancingPartners'],
        'detectedAt': (new Date(json['detectedAt'])),
    };
}

export function FinancingAnalysisViolationResourceToJSON(value?: FinancingAnalysisViolationResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'companyIdentityId': value['companyIdentityId'],
        'payingEntityId': value['payingEntityId'],
        'companyLegalIdentifier': CompanyLegalIdentifierResourceToJSON(value['companyLegalIdentifier']),
        'violationType': value['violationType'],
        'violationDescription': value['violationDescription'],
        'legalEntityIds': value['legalEntityIds'],
        'concernedFinancingPartners': value['concernedFinancingPartners'],
        'detectedAt': ((value['detectedAt']).toISOString()),
    };
}

